import { useContext } from 'react';
import { SideEffectsContext } from '../../providers/SideEffectsProvider';

const useSideEffects = () => {
  return useContext(SideEffectsContext);
};

export default useSideEffects;
